import "legacy/mobile-scripts";
import {configureJQueryAjaxPrefilter} from "commonUtils";

configureJQueryAjaxPrefilter();